import axios from 'axios';
export const api = axios.create({
  // baseURL: 'https://www.ubikon.in/api', // live server
  baseURL: 'https://ubikon.in/api',
});